<scale-button [variant]="buttonVariant" (click)="buttonClick(routerLink)">
  {{ buttonText }}</scale-button
>
